<div class="light-blue my-0 d-flex align-items-center">
<div class="container">
    <div class="row d-flex align-items-center">
        <div class="col-md-7 col-12 my-5 my-md-0">
                <picture>
                    <source srcset="assets/safetybox-vr-header.webp" type="image/webp">
                    <source srcset="assets/safetybox-vr-header.jpg" type="image/jpg">
                    <img src="assets/safetybox-vr-header.jpg" class="block-rounded" alt="An open box with the SafetyBoxVR logo that contains the PicoNeo3 VR headset" title="SafetyBoxVR" loading="lazy">
                </picture>
        </div>
        <div class="col-md-5 col-12 px-3 mb-5 mb-md-0">
            <div class="first-block">
              <h1 id="titre">{{'Votre' | translate}}
                <picture *ngIf="getCurrentLang() == 'fr'">
                    <source srcset="assets/safetybox_vr.webp" type="image/webp">
                    <source srcset="assets/safetybox_vr.png" type="image/png">
                    <img class="ml-2" src="assets/safetybox_vr.png" alt="logo of the SafetyBoxVR" title="SafetyBoxVR" loading="lazy">
                </picture>
                <br *ngIf="getCurrentLang() == 'fr'"> {{'clé en main' | translate}}<img *ngIf="getCurrentLang() == 'en'" class="ml-2" src="assets/safetybox_vr.png" alt="logo SafetyBoxVR" title="SafetyBoxVR" loading="lazy"></h1>
              <p class="mt-3 text-justify">{{'Immersive Factory vous propose de prendre en main votre planning de formation et d’animations en vous mettant à disposition un casque VR pendant un an' | translate}}</p>
                <div class="mb-3 mb-md-0 mt-4">
                    <button class="btn btn-immersive btn-rounded free-access-btn" [routerLink]="language.navigateAccordingToLang(['/about-us/o'])" [state]="{'prefillContact' : 'SafetyBox VR'}" title="contact"><i class="fas fa-envelope mr-2"></i>{{'Contact us' | translate}}</button>
                </div>
            </div>
        </div>
    </div>
</div>
</div>
<hr class="mt-0">


<div class="container py-5">
    <div class="row my-2 pb-3">
        <div class="col-12 col-md-6 px-4 mb-md-0 mb-4 justify-content-center">
            <span class="title">{{'Un casque VR prêt à l’emploi' | translate}}</span>
            <p class="text-justify mt-5">{{'Le casque de réalité virtuelle vous est livré réglé avec tous vos exercices installés. Vous n’avez pas besoin de connexion ou de wifi' | translate}}.</p>
            <p class="text-justify">{{'Le casque est complétement autonome. Vous n’avez plus qu’à le démarrer !' | translate}}</p>
        </div>
        <div class="col-12 col-md-6 px-4">
            <picture>
                <source srcset="assets/safetybox-vr-femme-pico3.webp" type="image/webp">
                <source srcset="assets/safetybox-vr-femme-pico3.jpg" type="image/jpg">
                <img class="block-rounded shadow" src="assets/safetybox-vr-femme-pico3.jpg" alt="A woman wearing a Pico Neo3 VR headset" title="A ready-to-use VR headset" loading="lazy">
            </picture>
        </div>
    </div>

    <hr class="my-5">

    <div class="row justify-content-center my-2 pt-3">
      <div class="col-12 col-md-6">
        <div class="block-pricing sub-middle">
          <div class="block-header red">
            <picture>
                <source srcset="assets/safetybox_vr_blanc.webp" type="image/webp">
                <source srcset="assets/safetybox_vr_blanc.png" type="image/png">
                <img src="assets/safetybox_vr_blanc.png" alt="logo safetybox vr" title="SafetyBoxVR" loading="lazy">
            </picture>
          </div>
          <div class="block-content">
            <div class="block-prices py-4">
              <div class="px-0">
                <div class="prices-loading" *ngIf="loading"></div>
                <div class="prices-value animate__animated animate__fadeIn text-center" *ngIf="!loading">
                  <div class="price-bundle">
                    <span class="mr-1">{{basketService.currencySymbol}}</span>
                    <span><app-currency [currency]="basketService.currentCurrency" [currencyvalue]="3990"></app-currency></span>
                    <span class="ht"> {{'HT' | translate}}</span>
                    <span>*</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="text-center mb-5">
              <picture>
                  <source srcset="assets/Tarifs_SafetyBox.webp" type="image/webp">
                  <source srcset="assets/Tarifs_SafetyBox.jpg" type="image/jpg">
                  <img src="assets/Tarifs_SafetyBox.jpg" class="w-100" alt="image safetybox vr" title="SafetyBoxVR" loading="lazy">
              </picture>
            </div>
            <div class="text-center mb-3">
              <button class="btn btn-red d-inline-block" [routerLink]="language.navigateAccordingToLang(['/about-us/o'])" [state]="{'prefillContact' : 'SafetyBox VR'}" title="contact">{{'Contact us' | translate}}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6 mt-4 mt-md-0">
            <span class="title">{{'Une SafetyBox tout-en-un !' | translate}}</span>
            <div class="d-flex mb-3 mt-5">
                <i class="fas fa-check-circle mr-3 custom-circle"></i>
                <p class="mb-0 text-justify">
                    {{'Un casque VR pendant 1 an, préinstallé et totalement autonome, livré chez vous' | translate}}
                </p>
            </div>
            <div class="d-flex mb-3">
                <i class="fas fa-check-circle mr-3 custom-circle"></i>
                <p class="mb-0 text-justify">
                    {{'Tous les exercices préinstallés' | translate}}
                </p>
            </div>
            <div class="d-flex mb-3">
                <i class="fas fa-check-circle mr-3 custom-circle"></i>
                <p class="mb-0 text-justify">
                    {{'Passages illimités de tous vos salariés' | translate}}
                </p>
            </div>
            <div class="d-flex mb-3">
                <i class="fas fa-check-circle mr-3 custom-circle"></i>
                <p class="mb-0 text-justify">
                    {{'Notices d’utilisation' | translate}}
                </p>
            </div>
            <div class="d-flex mb-3">
                <i class="fas fa-check-circle mr-3 custom-circle"></i>
                <p class="mb-0 text-justify">
                    {{'Support personnalisé et solution MDM installée' | translate}}
                </p>
            </div>
            <div class="d-flex mb-3">
                <i class="fas fa-check-circle mr-3 custom-circle"></i>
                <p class="mb-0 text-justify">
                    {{'Aide à la prise en main à distance' | translate}}
                </p>
            </div>
      </div>
		</div>


</div>


<hr class="mb-0 pb-0">

<div class="light-gray">
  <div class="container py-5">
      <div class="row my-5">
          <div class="col-12 col-md-6 mb-md-0 mb-4 pr-4 justify-content-center">
              <span class="title">{{'Pourquoi choisir Immersive Factory ?' | translate}}</span>
              <p class="text-justify mt-5">{{'Vous cherchez une nouvelle façon de proposer des formations sécurité à vos collaborateurs ?' | translate}}</p>
              <p class="text-justify">{{'Immersive Factory vous propose plus de 30 exercices immersifs pour répondre à vos besoins ! Nos exercices sont disponibles sur casque VR pour une immersion totale, interactive et un meilleur apprentissage. C’est le choix idéal pour l’apprentissage !' | translate}}.</p>
          </div>
          <div class="col-12 col-md-6">
            <div class="videoContainer block-rounded shadow">
                <video poster="https://immersivemisc.s3.eu-west-3.amazonaws.com/videos/posters/safetybox-vr-video-presentation.jpg" autoplay="autoplay" muted="muted" webkit-playsinline="true" playsinline="true" loop="loop" preload="auto">
                    <source src="https://immersivemisc.s3.eu-west-3.amazonaws.com/videos/{{'safetybox-vr-video-presentation-fr' | translate}}.webm" type="video/webm">
                    <source src="https://immersivemisc.s3.eu-west-3.amazonaws.com/videos/{{'safetybox-vr-video-presentation-fr' | translate}}.mp4" type="video/mp4">
                </video>
            </div>
          </div>
      </div>
  </div>
</div>


<hr class="mt-0 pt-0">

<!-- <app-they-trust-us></app-they-trust-us>

<hr> -->


<div class="container py-5">
    <div class="text-center mb-5">
        <span class="title sub-bar">{{'Exercices compatibles avec la' | translate}} SafetyBox
          <picture>
              <source srcset="assets/vr_logo.webp" type="image/webp">
              <source srcset="assets/vr_logo.png" type="image/png">
              <img class="img-logo mx-1" src="assets/vr_logo.png" alt="VR logo" title="VR" loading="lazy">
          </picture>
          ®</span>
    </div>
    <p class="text-justify-center">{{'Sensibilisez vos collaborateurs aux situations à risques sur le lieu de travail grâce à nos' | translate}} <span class="text-bleu">{{'exercices VR' | translate}}</span> {{'dédiés au' | translate}} <span class="text-bleu">{{'secteur HSE' | translate}}</span><i>{{' : travail en hauteur, chute de plain pied, équipements électriques, etc..' | translate}}</i></p>
    <div *ngIf="listProducts" class="my-4">
        <div class="row ml-0 mr-0">
          <app-product-card class="col-md-4 mt-4"  *ngFor="let product of listProducts" [product]="product"></app-product-card>
        </div>
    </div>
    <div class="row mb-4">
        <div class="col-12 blue mb-2 py-4 px-5 text-center shadow">
            <p class="bold">{{'Et bien plus encore !' | translate}}</p>
            <p>{{'Boostez la culture sécurité de votre entreprise au travers d’une approche ludique et immersive' | translate}}</p>
            <div class="my-2">
                <button class="btn btn-immersive btn-rounded" [routerLink]="language.navigateAccordingToLang(['/content'])" title="catalog"><i class="fas fa-envelope mr-2"></i>{{'Consulter le catalogue complet' | translate}}</button>
            </div>
        </div>
    </div>
</div>
